import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgDirections = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30 30",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "nonzero",
			d: "M28.756 13.994l-12.75-12.75a1.41 1.41 0 0 0-1.998 0l-12.75 12.75a1.41 1.41 0 0 0 0 1.998l12.75 12.75a1.41 1.41 0 0 0 1.998 0l12.75-12.75c.552-.539.552-1.431 0-1.998zm-10.923 4.548V15h-5.666v4.25H9.333v-5.667c0-.779.638-1.416 1.417-1.416h7.083V8.625l4.959 4.958-4.959 4.959z"
		})
	})
});
export default SvgDirections;
